// Base content type containing shared properties between different content types
export interface ContentType {
  id: string
  title: string
  tags: string[]
  createdAt: string
  updatedAt: string
  inBin?: boolean
}

// Note interface for decrypted note data
export interface Note extends ContentType {
  content: string
}

// Task interface for decrypted task data
export interface Task extends ContentType {
  description: string
  status: TaskStatus
  dueDate?: string
  index: number
}

// Tag interface for decrypted tag data
export interface Tag {
  id: string
  name: string
  color?: string
}

export interface GlobalTagsList {
  tags: Tag[]
}

// Enum for Task Status
export enum TaskStatus {
  TODO = "todo",
  DONE = "done",
}
